import { createSlice } from '@reduxjs/toolkit';
import { AuthorizationsState } from './types';
import { fetchAuthorizations } from './thunk';

const initialState: AuthorizationsState = {
  data: [],
  count: 0,
  next: null,
  previous: null,
  loading: false,
  error: null,
};

const authorizationsSlice = createSlice({
  name: 'workflows/authorizations',
  initialState,
  reducers: {
    resetAuthorizationsState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuthorizations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAuthorizations.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.count = payload.count;
        state.next = payload.next;
        state.previous = payload.previous;
        state.data = payload.results;
      })
      .addCase(fetchAuthorizations.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload ?? 'Failed to load licenses/permits';
      });
  },
});

export const { resetAuthorizationsState } = authorizationsSlice.actions;
export default authorizationsSlice.reducer;
